import React, { useContext } from "react"
import axios from "axios"

import cart from "../helpers/cart"

import styles from "./checkoutBtn.module.scss"
import { AppContext } from "./Context"


const CheckoutBtn = props => {
  const {
    showCartCount,
    className,
    loopCartToken,
  } = props

  const appState = useContext(AppContext)

  const cartItems = cart.getCart().map((item) => (
    {
      variantId: item.variantId,
      quantity: item.quantity
    }
  ))

  const createCheckout = () => {

    const hashedVariants = cartItems.map(variant => (
      {
        quantity: variant.quantity,
        variantId: Buffer.from(`gid://shopify/ProductVariant/${variant.variantId}`).toString('base64')
      }
    ))

    axios({
      url: 'https://shop.tamaramellon.com/api/2020-04/graphql.json',
      method: 'post',
      headers: {
        // 'X-Shopify-Storefront-Access-Token': process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
        'X-Shopify-Storefront-Access-Token': "14ddd2b4c87fb6bc9c77e95cf3bed2c5",
      },
      data: {
        query: `fragment UserErrorFragment on UserError {
          field
          message
        }
        fragment CheckoutFragment on Checkout {
          webUrl
        }
        mutation ($input: CheckoutCreateInput!) {
          checkoutCreate(input: $input) {
             userErrors {
              ...UserErrorFragment
            }
            checkout {
              ...CheckoutFragment
            }
          }
        }`,
        variables: {
          input: {
            lineItems: hashedVariants,
            presentmentCurrencyCode: "USD",
          }
        },
      },
    }).then(response => {
      const {
        checkoutCreate
      } = response.data.data

      if (checkoutCreate.userErrors.length > 0) {
        // console.log('CHECKOUT ERROR ', data.data.checkoutCreate.userErrors[0].message)
      } else {
        window ? window.location = checkoutCreate.checkout.webUrl : console.log('error')
      }
    })
  }

  const sendToLoop = () => {
    window ? window.location = `https://tamaramellon.loopreturns.com/#/cart/v2/${loopCartToken}` : console.log('error')
  }

  return (
    <button
      className={`${styles.btn} ${className || ""}`}
      onClick={loopCartToken ? sendToLoop : createCheckout}
    >
      Checkout
      {showCartCount &&
        <span className={styles.cartCount}>({appState.cartCount})</span>
      }
    </button>
  )
}


export default CheckoutBtn

